import React from 'react';
import { createRoot } from 'react-dom/client';
import ProgressBarContainer from 'components/ProgressBar/ProgressBarContainer';
import { Plugin } from '../../../types';
import { PLAYER_PLACEHOLDER_ID } from 'components/Player/Player';
const addProgressBarToPlayer = (programId: number) => {
  const progressBarContainer = document.createElement('div');
  progressBarContainer.setAttribute('id', 'progressbar-container');
  document.getElementById(PLAYER_PLACEHOLDER_ID)?.appendChild(progressBarContainer);
  const progressBarInDom = document.getElementById('progressbar-container');
  if (progressBarInDom) {
    const root = createRoot(progressBarInDom);
    root.render(<ProgressBarContainer id={programId} />);
  }
};
const removeProgressBarFromPlayer = () => {
  const progressBar = document.getElementById('progressbar-container');
  if (progressBar) progressBar.remove();
};
const PlayerProgressBar = (currentProductId: number): Plugin => {
  return (jwPlayer: jwplayer.JWPlayer, _) => {
    addProgressBarToPlayer(currentProductId);
    jwPlayer.on('beforePlay', () => {
      removeProgressBarFromPlayer();
    });
  };
};
export default PlayerProgressBar;